var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useRef, useCallback } from 'react';
import { createUseStyles } from 'react-jss';
import { useForceRerender, useUnmount } from '../../utils/hooks';
var useStyles = createUseStyles({
    container: {
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        position: 'absolute',
        borderRadius: 'inherit',
        overflow: 'hidden',
    },
    '@keyframes expandNfade': {
        '100%': {
            transform: 'translate(-50%, -50%)  scale(2)',
            opacity: 0,
        },
    },
    ripple: {
        animation: '$expandNfade ease-out .6s',
        position: 'absolute',
        transform: 'translate(-50%, -50%) scale(0)',
        opacity: 0.5,
    },
}, { name: 'RUIRipple' });
var RippleEffect = function () {
    var _a;
    var styles = useStyles();
    var containerRef = useRef(null);
    var points = useRef([]);
    var render = useForceRerender();
    // clear all existing points' timeouts before unmounting
    useUnmount(function () {
        points.current.forEach(function (point) { return clearTimeout(point.timerId); });
    });
    // removes a ripple origin point from the points array
    var removePoint = useCallback(function (id) {
        var index = points.current.findIndex(function (point) { return point.id === id; });
        points.current.splice(index, 1);
        render();
    }, []);
    // insert a ripple span at point of click
    var handleMouseDown = useCallback(function (e) {
        var _a = containerRef.current.getBoundingClientRect(), left = _a.left, top = _a.top;
        var _b = [e.clientX - left, e.clientY - top], x = _b[0], y = _b[1];
        // TODO: more robust random id
        var id = String(Math.random());
        var timerId = setTimeout(function () { return removePoint(id); }, 500);
        points.current = __spreadArray(__spreadArray([], points.current, true), [{ timerId: timerId, id: id, x: x, y: y }], false);
        render();
    }, []);
    // size needs to be recalculated on every render in case container has css position changes
    var _b = ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) || { height: 0, width: 0 }, height = _b.height, width = _b.width;
    var size = Math.max(height, width);
    return (React.createElement("span", { className: "RUIRipple-container ".concat(styles.container), ref: containerRef, onMouseDown: handleMouseDown }, points.current.map(function (point) { return (React.createElement("span", { key: point.id, className: "RUIRipple-ripple ".concat(styles.ripple), style: {
            width: size,
            height: size,
            borderRadius: size,
            left: point.x,
            top: point.y,
            backgroundColor: 'var(--RUI-ripple-color)',
        } })); })));
};
export default RippleEffect;
